import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faUser, faImage, faSave, faMailBulk, faBriefcase } from '@fortawesome/free-solid-svg-icons';

const EditClient = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [currentPhotoUrl, setCurrentPhotoUrl] = useState('');

  const [formData, setFormData] = useState({
    name: "",
    photoUrl: null,     
    email: "",
    jobTitle: "",
    projectIds: [],   
  });

  useEffect(() => {
    if (id) {
      axios.get(`/client/${id}`)
        .then(res => {
          const client = res.data;
          setFormData({
            name: client.name || '',
            photoUrl: null,
            email: client.email || '',
            jobTitle: client.jobTitle || '',
            projectIds: client.projects ? client.projects.map(p => p.id.toString()) : [],
          });
          setCurrentPhotoUrl(client.photoUrl || '');
        })
        .catch(err => {
          console.error('Erreur chargement client:', err);
          alert('Erreur chargement client');
        });
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      const uploadFile = /\.jfif$/i.test(selectedFile.name)
        ? new File([selectedFile], selectedFile.name.replace(/\.jfif$/i, '.jpg'), {
            type: selectedFile.type || 'image/jpeg',
          })
        : selectedFile;
      setFormData(prev => ({ ...prev, photoUrl: uploadFile }));
    }
  };

  const onCancel = (e) => {
    e.preventDefault();
    navigate('/admin/clients');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');

    try {
      const data = new FormData();
      data.append('name', formData.name);
      data.append('jobTitle', formData.jobTitle);
      data.append('email', formData.email);

      formData.projectIds.forEach(id => data.append('projectIds[]', id));

      if (formData.photoUrl instanceof File) {
        data.append('photoUrl', formData.photoUrl);
      }

      await axios.patch(`/client/id/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Client modifié avec succès !');
      navigate('/admin/clients');
    } catch (error) {
      console.error('Erreur modification client:', error);
      const apiMessage = error.response?.data?.message;
      alert(Array.isArray(apiMessage) ? apiMessage.join('\n') : (apiMessage || 'Erreur lors de la modification'));

    }
  };

  return (
    <div className="form-container">
      <div className="form-header">
        <button className="back-button" onClick={onCancel}>
          <FontAwesomeIcon icon={faArrowLeft} /> Retour
        </button>
        <h3>Modifier les infos du client</h3>
      </div>

      <div className="form-card">
        <form onSubmit={handleSubmit} className="client-form" encType="multipart/form-data">
          <div className="form-section">

            {/* Nom */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faUser} className="label-icon" /> Nom du client
              </label>
              <input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Entrez le nom du client"
                className="form-input"
                required
              />
            </div>

            {/* Email */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faMailBulk} className="label-icon" /> E-mail
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="L'e-mail du client"
                className="form-input"
                required
              />
            </div>

            {/* Poste */}
            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faBriefcase} className="label-icon" /> Poste / fonction (facultatif)
              </label>
              <input
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                placeholder="Ingénieur"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <FontAwesomeIcon icon={faImage} className="label-icon" /> Image
              </label>
              {(formData.photoUrl || currentPhotoUrl) && (
                <img
                  src={
                    formData.photoUrl instanceof File
                      ? URL.createObjectURL(formData.photoUrl)
                      : `/${currentPhotoUrl.replace(/^\/+/, '')}`
                  }
                  alt="Image du client"
                  onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  className="project-image"
                  style={{ display: 'block', width: 220, height: 140, objectFit: 'cover', borderRadius: 10, marginBottom: 12 }}
                />
              )}
              <input
                type="file"
                name="photoUrl"
                accept="image/png,image/jpeg,image/jpg,image/jfif,image/svg+xml,.jfif"
                onChange={handleFileChange}
                className="form-input"
              />
            </div>

          </div>

          {/* Boutons */}
          <div className="form-actions">
            <button type="submit" className="btn-save">
              <FontAwesomeIcon icon={faSave} /> Enregistrer
            </button>
            <button type="button" className="cancel-button" onClick={onCancel}>
              <FontAwesomeIcon icon={faArrowLeft} /> Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditClient;
